import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

/**
 * Base Api xử lý chung cho danh mục
 */
export default class DIApi extends BaseAPI {
  apiName = 'DI';

  /**
   * Lấy tất cả items
   * @param {*} param tham số cần lấy dữ liệu
   * @return {*} danh sách bản ghi
   */
  getItems(param) {
    const request = {
      url: this.getAPIUrl(),
      data: param,
    };

    return httpClient.getAsync(request);
  }

  /**
   * thực hiện update trạng thái
   * @param {} param
   * @returns
   */

  updateActionStatus(param) {
    const request = {
      url: this.getAPIUrl() + '/Status',
      data: param,
    };
    return httpClient.putAsync(request, true);
  }

  /**
   * thực hiện update trạng thái
   * @param {} param
   * @returns
   */

  validateEnactArise(param) {
    const request = {
      url: this.getAPIUrl() + '/EnactArise',
      data: param,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy tất cả items
   * @param {*} param tham số cần lấy dữ liệu
   * @return {*} danh sách bản ghi
   */
  getEstimate(param) {
    const request = {
      url: this.getAPIUrl() + '/Estimate',
      data: param,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy ra dữ liệu không tồn tại với estimate
   * @param {*} param
   * @returns danh sách bản ghi
   */
  getEstimateDictionary(param) {
    const request = {
      url: this.getAPIUrl() + '/EstimateDictonary',
      data: param,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Lấy ra dữ liệu không tồn tại với estimate
   * @param {*} param
   * @returns danh sách bản ghi
   */
  getEstimateArrgrateDictionary(param) {
    const request = {
      url: this.getAPIUrl() + '/EstimateArrgrateDictonary',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy ra dữ liệu cmmt quốc gia và mục tiêu thực hiên
   * @param {*} param
   * @returns danh sách bản ghi
   */
  getAllocationDictonary(param) {
    const request = {
      url: this.getAPIUrl() + '/AllocationDictonary',
      data: param,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Lấy 1 bản ghi theo id
   * @param {*} param tham số cần lấy dữ liệu
   * @return {*} bản ghi cần lấy
   */
  getById(param) {
    const request = {
      url: this.getAPIUrl() + '/Master/' + param?.id,
      data: param,
    };

    return httpClient.getAsync(request);
  }

  /**
   * check phát sinh cha
   * nxhinh 12.07.2024
   */
  async parentAriseChecking(payload, controllerName) {
    // this.controllerName = controllerName ? controllerName : this.controllerName;
    this.controllerName = controllerName ? controllerName : this.controllerName;
    const request = {
      url: this.getAPIUrl() + '/ParentAriseChecking',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * sinh mới mã cho dữ liệu
   * @param {*} param
   */
  uniqueAutoCode(param) {
    const request = {
      url: this.getAPIUrl() + '/UniqueAutoCode',
      data: {
        duplicateCode: param,
      },
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu phân quyền xem, sửa xóa.
   * @returns
   */
  getRoleDictionary() {
    const request = {
      url: this.getAPIUrl() + '/RoleDictionary',
    };
    return httpClient.getAsync(request);
  }
}
